import { Row, Col } from "react-bootstrap";

import classes from "../Inventory/inventory.module.scss";

import { hasPermission } from "@/services/Utils";

const EmptyContainerFunctionsSelect = ({ setShowConfirm, permissions }) => {
	return (
		<Row className={classes.actions}>
			<Col className={classes.actionRow} md={12}>
				<div className={classes.label}>Seleccione una opción</div>

				{hasPermission("delete", permissions) && (
					<div className={`${classes.optionButton} ${classes.deleteInventory}`} onClick={() => setShowConfirm(true)}>
						<span>
							<div>Eliminar</div> envases seleccionados{" "}
						</span>
					</div>
				)}
			</Col>
		</Row>
	);
};

export default EmptyContainerFunctionsSelect;
